import {getFoodProductDetails} from '@/lib/food/foodService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getFoodProductQueryKey(foodProductId: string) {
  return ['foodProduct', foodProductId] as const
}

export function getFoodProductQueryOptions(foodProductId: string) {
  return queryOptions({
    queryKey: getFoodProductQueryKey(foodProductId),
    queryFn: async ({signal}) => getFoodProductDetails({foodProductId, signal}),
    throwOnError: false,
    ...NO_REFETCH_OPTIONS,
  })
}

export function useFoodProduct(foodProductId: string) {
  return useQuery(getFoodProductQueryOptions(foodProductId))
}
